/** In order. `harder` spotlights Intermediate and Expert as one step. */
export const HOME_TOUR_STEPS = ['daily', 'harder'];
/** How long each step holds before advancing (or, on the last, ending). */
export const HOME_TOUR_STEP_MS = 1200;
/**
 * Not seen yet, AND a player who entered through Module 116's first visit.
 * Both, because the flag alone would tour every earlier player (none of whom
 * has it) — and they already know the home screen.
 */
export function homeTourEligible(inputs) {
    return !inputs.seenHomeTour && inputs.bootedIntoPuzzle;
}
export function initialHomeTour() {
    return { kind: 'running', step: HOME_TOUR_STEPS[0], elapsedMs: 0, paused: [] };
}
export function homeTourReducer(state, event) {
    if (state.kind === 'done')
        return state;
    switch (event.type) {
        case 'skip':
            return { kind: 'done', outcome: 'skipped', target: event.target ?? null };
        case 'pause':
            return { ...state, paused: addReason(state.paused, event.reason) };
        case 'resume':
            return { ...state, paused: state.paused.filter((r) => r !== event.reason) };
        case 'tick': {
            if (state.paused.length > 0 || event.ms <= 0)
                return state;
            const elapsedMs = state.elapsedMs + event.ms;
            if (elapsedMs < HOME_TOUR_STEP_MS)
                return { ...state, elapsedMs };
            // One step per tick at most: a long frame (a stalled tab that was never
            // reported hidden) advances the tour by one step, never through it.
            const next = HOME_TOUR_STEPS[HOME_TOUR_STEPS.indexOf(state.step) + 1];
            return next
                ? { kind: 'running', step: next, elapsedMs: 0, paused: state.paused }
                : { kind: 'done', outcome: 'completed', target: null };
        }
    }
}
function addReason(paused, reason) {
    return paused.includes(reason) ? paused : [...paused, reason];
}
